import React, { useState } from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';
import AdventCalendar from './components/AdventCalendar';
import ProofBoard from './components/ProofBoard';
import CommunitySuggestions from './components/CommunitySuggestions';
import SnowOverlay from './components/SnowOverlay';
import { Tab } from './types';

const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.ADVENT);

  return (
    <div className="relative min-h-screen bg-[#0F0F0F] text-white overflow-x-hidden selection:bg-christmas-gold selection:text-black">
      {/* Background Elements */}
      <SnowOverlay />
      
      {/* Decorative Gradient Blob */}
      <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-christmas-red/10 blur-[120px] rounded-full pointer-events-none z-0"></div>
      <div className="fixed bottom-0 right-0 w-[600px] h-[400px] bg-christmas-green/10 blur-[100px] rounded-full pointer-events-none z-0"></div>

      {/* Main Content */}
      <div className="relative z-10">
        <Header />
        
        <main className="mt-6 flex flex-col items-center">
          <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
          
          <div className="w-full animate-[fadeIn_0.5s_ease-out]">
            {activeTab === Tab.ADVENT && <AdventCalendar />}
            {activeTab === Tab.PROOF && <ProofBoard />}
            {activeTab === Tab.SUGGESTIONS && <CommunitySuggestions />}
          </div>
        </main>

        <footer className="w-full text-center py-8 text-zinc-600 text-xs">
          <p>© 2025 21 Days Until Christmas. Built for the community.</p>
        </footer>
      </div>
      
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default App;